import type { Letterhead, SablonSurum } from '../types'

export const COMPANY = {
  name: 'Ürünver',
  legalName: 'Ürünver Yazılım ve Teknoloji A.Ş.',
  department: 'İnsan Kaynakları Direktörlüğü',
  logo: '/urunver.png',
} as const

export const DEFAULT_LETTERHEAD: Letterhead = {
  companyName: COMPANY.name,
  legalName: COMPANY.legalName,
  department: COMPANY.department,
}

export function resolveLetterhead(surum: SablonSurum): Letterhead {
  const custom = surum.letterhead ?? {}
  return {
    companyName: custom.companyName?.trim() || DEFAULT_LETTERHEAD.companyName,
    legalName: custom.legalName?.trim() || DEFAULT_LETTERHEAD.legalName,
    department: custom.department?.trim() || DEFAULT_LETTERHEAD.department,
  }
}
